import { createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const buildPersistConfig = (key, { blacklist, whitelist, migrations = {}, transforms = [], version = 15 }) => ({
  key,
  version,
  storage,
  blacklist,
  whitelist,
  transforms,
  migrate: createMigrate(migrations, { debug: false })
});

export default buildPersistConfig;
